import BidsOsagoService from '@/api/BidsOsagoService.js'
import Vue from 'vue'
export const bidsOsagoModule = {
  namespaced: true,
  state: () => ({
    bidsOsagoData: [],
    bidsOsagoLoadStatus: 'request',
    paginationPromocodesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPromocodesStateParams.total /
        state.paginationPromocodesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.bidsOsagoData = [...data]
    },
    create(state, data) {
      state.bidsOsagoData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.bidsOsagoData.findIndex(
        (x) => x.request_service__id == data.id
      )
      Object.assign(state.bidsOsagoData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.bidsOsagoData.findIndex(
        (x) => x.request_service__id == id
      )
      state.bidsOsagoData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPromocodesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.bidsOsagoLoadStatus = 'request'
    },
    load_success(state) {
      state.bidsOsagoLoadStatus = 'success'
    },
    load_error(state) {
      state.bidsOsagoLoadStatus = 'error'
    }
  },
  actions: {
    getBidsOsagoAll({ commit }, params) {
      commit('load_request')

      BidsOsagoService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createBidsOsagoData({ commit }, createData) {
      BidsOsagoService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editBidsOsagoMultiple({ commit }, { id, dataEdit }) {
      BidsOsagoService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteBidsOsagoData({ commit }, id) {
      // commit("load_request");
      BidsOsagoService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
